import {
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from "ag-grid-community";
import { DependencyList, useEffect, useState } from "react";
import { ServerSideTypes } from "../common/CommonTypes";

export const useAgGridCustomDatasource = (
  func: (...args: any[]) => Promise<ServerSideTypes.IResult<any>>,
  args: any[],
  refreshCondition: DependencyList,
  pageSizeNum: number = 10
): [IServerSideDatasource, number, () => void] => {
  const [totalElements, setTotalElements] = useState(1);

  const getData = (params: IServerSideGetRowsParams<any>) => {
    const startRow = params.request.startRow ? params.request.startRow : 0;
    const endRow = params.request.endRow;

    const sortCode = params.request.sortModel[0]?.colId;
    const sortDirection  = params.request.sortModel[0]?.sort;


    let pageSize = pageSizeNum;
    if (
      endRow !== null &&
      endRow !== undefined &&
      startRow !== null &&
      startRow !== undefined
    ) {
      pageSize = endRow - startRow;
    }

    const pageNumber = startRow / pageSize;

    const serverParams: ServerSideTypes.IParams = {
      pageNumber,
      pageSize,
      sortCode,
      sortDirection,
    };

    if (args) {
      func(...args, serverParams).then(
        (response) => {
          setTotalElements(response.totalElements);
          params.success({
            rowData: response.content,
            rowCount: response.totalElements,
          });
        },
        (reject) => {
          setTotalElements(0);
          params.fail();
        }
      );
    }
  };

  const [datasource, setDatacource] = useState<IServerSideDatasource>({
    getRows: getData,
  });

  const updateDatasource = () => {
    setDatacource({ getRows: getData });
  };

  useEffect(() => {
    updateDatasource();
  }, refreshCondition);

  return [datasource, totalElements, updateDatasource];
};
